import * as MD from "@material-ui/core";
import * as React from "react";
import { I18N, ILocaleInfos } from "../Store/I18n/Types";
import { YacastPlayer } from "@yacast/react-player";

import { Dispatch } from "redux";
import { IApplicationState } from "../Store";
import { connect } from "react-redux";

import { setLocale } from "../Store/I18n/Actions";
import { Locales } from "../Store/I18n/Constants";
import { IUserState } from "../Store/User/Types";
import { IPlayerState } from "../Store/Player/Types";
import { ISearchState } from "../Store/Search/Types";

const styles = (theme: any) =>
  MD.createStyles({
    closeButton: {
      position: "absolute",
      right: "0px",
      top: "4px",
      color: theme.palette.grey[500],
    },

    formControl: {
      width: "100%",
      position: "absolute",
    },
    searchButton: {
      marginTop: "8px",
      paddingLeft: "5px",
      paddingRight: "5px",
      paddingTop: "0px",
      paddingBottom: "0px",
      cursor: "pointer",
    },
    toggleDiv: {
      width: "100%",
    },
    row: {
      padding: "0px",
      display: "flex",
      overflow: "hidden",
      position: "inherit",
      maxHeight: "45px",
    },
    cellXs: {
      fontSize: "x-small",
      alignItems: "center",
      paddingLeft: "2px",
      paddingRight: "0px",
    },
    rowHead: {
      color: "#d6d3d3",
      textTransform: "uppercase",
      paddingTop: "0px",
      paddingLeft: "10px",
      paddingBottom: "0px",
      backgroundColor: theme.palette.background.paper,
      position: "sticky",
      top: "0px",
      display: "table-cell",
      borderBottomWidth: "inherit",
    },
  });

type DialogAllProps = MD.WithStyles<typeof styles> & MD.WithTheme;

export interface DialogTitleProps extends DialogAllProps {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

interface IState {
  openState: boolean;
  expanded: boolean;
}
interface IPropsFromDispatch {}
interface IPropsFromState {
  i18n: I18N;
  user: IUserState;
  player: IPlayerState;
  localeInfos: ILocaleInfos;
  search: ISearchState;
}
interface IOwnProps {
  open: boolean;
  mediaID: number;
  mediaName: string;
  startDate: number;
  endDate: number;
}

type VideoPlayerAllProps = MD.WithTheme &
  MD.WithStyles<typeof styles> &
  IPropsFromState &
  IPropsFromDispatch &
  IOwnProps;

export class VideoPlayerComponent extends React.Component<
  VideoPlayerAllProps,
  IState
> {
  public constructor(props: VideoPlayerAllProps) {
    super(props);
    this.state = {
      openState: false,
      expanded: false,
    };
  }
  public componentDidMount() {}

  public render() {
    const { player, user } = this.props;
    let endDate = player.videoPlayerEndDate;
    let startDate = player.videoPlayerStartDate;
    let duration = (endDate - startDate) / 1000;
    let timelineDuration = duration + 30 * 60;
    let mediaName = "";
    if (user.allMediasID.length === 0) {
      return "Loading..";
    } else if (
      user.medias !== null &&
      Object.keys(user.medias) &&
      Object.keys(user.medias).length > 0
    ) {
      let medias: any = user.medias;
      let media: any = medias.filter((x: any) => x.id === player.mediaID);
      mediaName = media.name;
    }
    return (
      <div style={{ width: "50%" }}>
        <YacastPlayer
          apiKey={user.tokenPlayer}
          mediaName={mediaName}
          mediaID={player.mediaID}
          start={new Date(startDate * 1000 - 1000)}
          autoplay={true}
          timelineDuration={timelineDuration}
          timelineHaveReadjustedEPG={true}
          timelineHaveMusicEPG={false}
          selectionEnd={new Date(endDate * 1000)}
          selectionStart={new Date(startDate * 1000)}
          initialZoom={0}
          aclToken={this.props.user.token}
        />
      </div>
    );
  }
}

const mapStateToProps = ({
  i18n,
  user,
  player,
  search,
}: IApplicationState) => ({
  i18n: i18n.i18n,
  user,
  player,
  search,
  localeInfos: i18n.localeInfos,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  loadI18n: (locale: Locales) => dispatch(setLocale(locale)),
});

export const VideoPlayer = connect(
  mapStateToProps,
  mapDispatchToProps
)(MD.withTheme(MD.withStyles(styles)(VideoPlayerComponent)));
